import { Box, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DEFAULT_DF_REPORT } from '../form-branch'

const OpDF = () => {
    const { t } = useTranslation()
    const optionDF = [
        {
            name: t('BRANCH.TAB.SENTTING.DF_TREAMENT_PAY'), value: DEFAULT_DF_REPORT.PAY,
            component: <DF showType='PAY' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.DF_TREAMENT_OP'), value: DEFAULT_DF_REPORT.OP,
            component: <DF showType='OP' />,
        }
    ]
    return (optionDF)
}

export default OpDF

interface DFProps {
    showType: 'PAY' | 'OP'
}
const DF = (props: DFProps) => {
    const { showType } = props
    const { t } = useTranslation()
    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box >
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom='8px'>
                    {t('BRANCH.TAB.SENTTING.DF_TREAMENT')}
                </Typography>
            </Box>

            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.DF_TREAMENT_${showType}`)}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='16px' color='#5A5A5A'>
                    {t(`BRANCH.TAB.SENTTING.DF_TREAMENT_${showType}_SUB`)}
                </Typography>
            </Box>

            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.EXAMPLE_SHORT`)}
                </Typography>
                <Box marginTop="8px" padding="16px" bgcolor={'#ffffff'}>
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.TREATMENT_COST`)}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {`1000`} {t(`CURRENCY_CHANGE.TH`)}
                            </Typography>
                        </Grid >
                    </Grid>
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {t(`DF`)}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {t(`50%`)}
                            </Typography>
                        </Grid >
                    </Grid>
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.PATIENT_PAYMENT`)}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {`500`} {t(`CURRENCY_CHANGE.TH`)}
                            </Typography>
                        </Grid >
                    </Grid>
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {t(`BRANCH.TAB.SENTTING.DENTIST_RECEIVES_DF`)}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {t(`(${showType === 'OP' ? '1000' : '500'} x 50%)`)}
                            </Typography>
                        </Grid >
                    </Grid>
                    <Grid container item>
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {``}
                            </Typography>
                        </Grid >
                        <Grid item sm={6}>
                            <Typography fontSize={'16px'} fontWeight={'400'} fontStyle="italic" paddingLeft='20px' color='#5A5A5A'>
                                {`= ${showType === 'OP' ? '500' : '250'}`} {t(`CURRENCY_CHANGE.TH`)}
                            </Typography>
                        </Grid >
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}